const Color = {
  Red: "red",
  DarkRed: "dark_red",
  Orange: "orange",
  Amber: "amber",
  Yellow: "yellow",
  Lime: "lime",
  Green: "green",
  DarkEmerald: "dark_emerald",
  Emerald: "emerald",
  DarkerBlue: "darker_blue",
  DarkBlue: "dark_blue",
  Blue: "blue",
  LightBlue: "light_blue",
  Gray: "gray"
};
export {
  Color
};
//# sourceMappingURL=colors.js.map
